import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { Section } from '~/eds/src/components/Section/Section';

export interface UserManagementSectionProps {
  authenticatedUserCount: number;
  isChangeDetected?: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const UserManagementSection = ({
  disabled = false,
  authenticatedUserCount = 0,
  onClick = () => {},
  isChangeDetected = false,
}: UserManagementSectionProps) => {
  const intl = useIntl();

  return (
    <Section
      disabled={disabled}
      align="flex-start"
      title={intl.formatMessage(
        {
          id: 'NewESignature.ESignatureIntegrationCard.AuthenticatedUsersCountLabel',
          defaultMessage:
            '{count, plural, one {# authenticated user} other {# authenticated users}}',
          description:
            "Label showing count of authenticated users. Example: count = '3'",
        },
        { count: authenticatedUserCount },
      )}
    >
      <Button
        disabled={isChangeDetected || disabled}
        text={intl.formatMessage({
          id: 'NewESignature.ESignatureIntegrationCard.Manage',
          defaultMessage: 'Manage',
          description: 'Manage button text',
        })}
        onClick={onClick}
      />
    </Section>
  );
};
